import { atom } from 'infrastructure/state/jotai.wrapper'

export const drawerOpenAtom = atom(true)

export const drawOpenToggleAtom = atom(
  (get) => {
    return get(drawerOpenAtom)
  },
  (get, set) => {
    set(drawerOpenAtom, !get(drawerOpenAtom))
  },
)
